module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_nia_m.224a96c5186ae5066245708d32a95b6a.png";